export default __webpack_public_path__ + "static/media/firstName.12d38176.mp4";